import img1 from "../../images/waves-project.JPG";

export default [
  {
    id: 1,
    name: "Waves-Project",
    description:
      "This is a React app with Redux where users can find any movie of their choice and get information about that movie. The data is taken from an API which reflects IMDB movie data. This app can be enhanced as a cinema website where people can buy their tickets for the movies.",
    code_link: "https://github.com/nagireddy1234/E-commerce_capstoneProject",
    deploy_link: "https://github.com/nagireddy1234/E-commerce_capstoneProject",
    tools: ["React Js", "Redux", "local storage"],
    icons: ["fab", "react"],
    image: img1,
    image_describe: "Waves-Project",
  },
];
